<template>
  <div class="s_bf2 s_flex_ali box p-12" >
    <img src="@/assets/images/normal.png" class="width-67 height-67 " />
    <div class='info flex_1 m-l-10' >
      <p class="fz-14 s_lin_h21 s_c13">金龙鱼 东北大米 5kg 乳玉皇妃稻香贡 米 大米 十斤...</p>
      <div class="s_flex_bian_c" >
          <div class="s_flex_ali" v-if="data.params.is_show_price">
            <span class="s_c999 fz-12 m-r-5">零售价</span><span class="fz-18 themeColor " :style="'color:'+gobleStyle.themeColor">￥ 99.00</span>
            </div>
          <div class="width-70 height-26 s_bor10 text-ac s_lin_h26  s_cfff" :style="'background-color:'+gobleStyle.themeColor" v-if="data.params.is_show">商品详情</div>
      </div>
    </div>
  </div>
</template>
<script>
  import * as Icon from "@ant-design/icons-vue";
  import store from "@/store";
import { inject } from '@vue/runtime-core';
  export default {
    props: { data: Object,gobleStyle:Object },
    components: { ...Icon },
    name: "goods",
    setup(){
      return{
        info: store.state.user.info
      }
    }
  }
</script>
<style lang="less" scoped>

</style>